var _TypeBuilder_name, _TypeBuilder_namespace, _TypeBuilder_baseType, _TypeBuilder_isArray, _TypeBuilder_factory;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Type from "./Type";
import isNullOrEmpty from '../TypeHelpers/isNullOrEmpty';
import NullReferenceException from '../Exceptions/NullReferenceException';
export default class TypeBuilder {
    constructor() {
        _TypeBuilder_name.set(this, '');
        _TypeBuilder_namespace.set(this, '');
        _TypeBuilder_baseType.set(this, Type.getType(undefined));
        _TypeBuilder_isArray.set(this, false);
        _TypeBuilder_factory.set(this, () => undefined);
        this.setName = name => {
            __classPrivateFieldSet(this, _TypeBuilder_name, name, "f");
            return this;
        };
        this.setNamespace = namespace => {
            __classPrivateFieldSet(this, _TypeBuilder_namespace, namespace, "f");
            return this;
        };
        this.deriveFrom = type => {
            __classPrivateFieldSet(this, _TypeBuilder_baseType, type, "f");
            return this;
        };
        this.factory = constructor => {
            __classPrivateFieldSet(this, _TypeBuilder_factory, (...args) => new constructor(...args), "f");
            return this;
        };
    }
    build() {
        if (isNullOrEmpty(__classPrivateFieldGet(this, _TypeBuilder_name, "f"))) {
            throw new NullReferenceException();
        }
        const type = {
            fullName: isNullOrEmpty(__classPrivateFieldGet(this, _TypeBuilder_namespace, "f")) ? __classPrivateFieldGet(this, _TypeBuilder_name, "f") : `${__classPrivateFieldGet(this, _TypeBuilder_namespace, "f")}.${__classPrivateFieldGet(this, _TypeBuilder_name, "f")}`,
            name: __classPrivateFieldGet(this, _TypeBuilder_name, "f"),
            namespace: __classPrivateFieldGet(this, _TypeBuilder_namespace, "f"),
            baseType: __classPrivateFieldGet(this, _TypeBuilder_baseType, "f"),
            isArray: __classPrivateFieldGet(this, _TypeBuilder_isArray, "f"),
            factory: __classPrivateFieldGet(this, _TypeBuilder_factory, "f")
        };
        Object.seal(type);
        return type;
    }
}
_TypeBuilder_name = new WeakMap(), _TypeBuilder_namespace = new WeakMap(), _TypeBuilder_baseType = new WeakMap(), _TypeBuilder_isArray = new WeakMap(), _TypeBuilder_factory = new WeakMap();
